import React from "react";
import Hero from "./Hero";
import TopFund from "./TopFund";
import MyOctopi from "./MyOctopi";
import Wagmi from "./Wagmi";
import HowUnique from "./HowUnique";
import { useOutletContext } from "react-router-dom";

const Home = () => {
  const [
    siteDetails,
    walletAddress,
    connectWallet,
    isWalletConnected,
    nftData,
    ,
    nftTop,
    loading,
    topLoading,
    ,
    ,
  ] = useOutletContext();
  return (
    <div>
      <Hero />
      <TopFund
        siteDetails={siteDetails}
        connectWallet={connectWallet}
        isWalletConnected={isWalletConnected}
        nftTop={nftTop}
        loading={topLoading}
      />
      <MyOctopi
        walletAddress={walletAddress}
        nftData={nftData}
        loading={loading}
      />
      <HowUnique />
      <Wagmi />
    </div>
  );
};

export default Home;
